import { h } from "preact";
import { useState, useEffect, } from "preact/hooks";
import { Box, Button, Grid, Paper, Stepper, Stack, Step, StepLabel, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";

import OnboardingDialog from "../PopUps/OnboardingDialog";
import Deal1 from "../Deal/Deal1";
import Localisation3 from "../Common/Localisation3";
import BienDescriptif from "../RealEstate/BienDescriptif";
import BiensDuDeal from "../RealEstate/BiensDuDeal";
import DealPrice from "../RealEstate/DealPrice";

import AccountBoxIcon from "@mui/icons-material/AccountBox";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	margin: {
		margin: theme.spacing(1),
	},
	withoutLabel: {
		marginTop: theme.spacing(3),
	},
	textField: {},
	textField2: { minWidth: "400px" },
	option: {
		fontSize: 15,
		"& > span": {
			marginRight: 10,
			fontSize: 18,
		},
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: "#fff",
	},
}));

export default function DealNewA({ id, step }) {
	console.log("DealNewA", step)
	const classes = useStyles();
	const [steps, setSteps] = useState([]);

	const [state, setState] = useState({ loaded: false, mode: "AM", tunnel: true });
	const handleChangeLoc = (loc) => {
		//console.log(loc.center[0], loc.center[1]);
		setState({ ...state, loc: loc, has_loc: loc !== undefined, full_adr: loc ? loc.Label : undefined });
	};

	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/f37ab7f1a7284e1ebd053bcd35acb51f/" + id + "/" + step, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							...res.pld,
							loaded: true,
						}));
						setSteps([
							<span
							// onClick={() => {
							// 	window.location.href = "/newdeala/" + res.pld.deal_uid + "/0";
							// }}
							>
								Le{res.pld.nb_assets > 1 ? "s" : ""} bien{res.pld.nb_assets > 1 ? "s" : ""}
							</span>,
							<span
							// onClick={() => {
							// 	window.location.href = "/newdeala/" + res.pld.deal_uid + "/2";
							// }}
							>
								Le prix
							</span>,
							<span
							// onClick={() => {
							// 	window.location.href = "/newdeala/" + res.pld.deal_uid + "/3";
							// }}
							>
								Les vendeurs
							</span>,
							<span
							// onClick={() => {
							// 	window.location.href = "/newdeala/" + res.pld.deal_uid + "/4";
							// }}
							>
								Récapitulatif
							</span>,
							// <spa
						]);
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);

	const getAgregateState = (st) => {
		switch (st) {
			case "0":
				return 0;
				break;
			case "1":
				return 0;
				break;
			case "1_2":
				return 0;
				break;
			case "1_3":
				return 0;
				break;
			case "2":
				return 1;
				break;
			case "3":
				return 2;
				break;
			case "4":
				return 3;
				break;
		}
	};
	const sendLoc = () => {

		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				loc: state.loc,
				uid: id,
				addr_line1: state.addr_line1,
				addr_zip_code: state.addr_zip_code,
				addr_city: state.addr_city,
			}),
		};

		fetch("/api/d42ab0ab458e4ff89c6a39c9d1c8f495", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						window.location.href = "/newdeala/" + res.re + "/1";

						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	if (state.loaded === false) return false;

	return (
		<div style="padding: 10px; ">
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Paper style="padding: 5px;">
						{" "}
						<Stepper activeStep={getAgregateState(step)} alternativeLabel>
							{steps.map((label) => (
								<Step key={label}>
									<StepLabel>{label}</StepLabel>
								</Step>
							))}
						</Stepper>
					</Paper>
				</Grid>
				<Grid item xs={12} md={3}>
					{step === "0" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
							<Typography variant="h5">Merci d'indiquer l'adresse du bien que vous souhaitez aider à vendre.</Typography>
						</Paper>
					)}
					{step === "2" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">

							<Typography variant="h5">Ici vous devez désigner le prix net vendeur du bien que vous souhaitez aider à vendre.</Typography>
						</Paper>
					)}

					{["1", "1_2", "1_3"].includes(step) && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
							<Typography variant="h5">
								Ici vous devez décrire le bien que vous souhaitez aider à vendre:
							</Typography>
							<Typography variant="body1">&nbsp;</Typography>
							<Typography variant="body1">- Indiquez le type de bien et rédigez un descriptif,</Typography>
							<Typography variant="body1">- Complétez les caractéristiques du bien,</Typography>
							<Typography variant="body1">- Envoyez des photos mettant le bien en valeur.</Typography>
						</Paper>
					)}
					{step === "3" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
							<Typography variant="h5">Ici vous devez désigner les personnes propriétaires du bien.</Typography>
						</Paper>
					)}
					{step === "4" && (
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
							<Typography variant="h5"></Typography>
						</Paper>
					)}
				</Grid>
				<Grid item xs={12} md={9}>
					<Paper style="padding: 10px; min-height: 300px;">
						{step === "0" && state.assets && state.assets.length > 0 && <BiensDuDeal setUpperState={setState} upperState={state} />}
						{step === "0" && state.assets && state.assets.length == 0 && <Stack style="height: 100%">
							<Localisation3 upperState={state} mode="ADR" upperSendLoc={handleChangeLoc} />
							<Box display={"flex"} justifyContent="flex-end">
								<Box>
									<Button
										variant="contained"
										onClick={sendLoc}
										style="margin-top: 20px;"
										disabled={!state.loc}
									>
										valider
									</Button>
								</Box>
							</Box>

						</Stack>}

						{(step === "1" || step === "1_2" || step === "1_3") && <BienDescriptif setUpperState={setState} upperState={state} tab={step} />}
						{/* {step === "1_2" && <BienDescriptif setUpperState={setState} upperState={state} tab={1} />}
						{step === "1_3" && <BienDescriptif setUpperState={setState} upperState={state} tab={2} />} */}
						{step === "2" && <DealPrice setUpperState={setState} upperState={state} mode="A" />}
						{step === "3" && <Deal1 upperState={state} />}
						{step === "4" && (
							<div>
								<Typography variant="h5" style="margin-bottom: 10px;">
									Félicitations !
								</Typography>
								<Typography variant="body1" style="margin-bottom: 10px;">
									En résumé, vous voulez aider à vendre :
								</Typography>
								{state.assets.map((asset) => {
									return (
										<Typography variant="body1" style="margin-bottom: 10px;">
											Un {asset.type_name} {asset.srf !== null ? ` de ${asset.srf} m2` : null} situé au {asset.a}
										</Typography>
									);
								})}
								<Typography variant="body1" style="margin-bottom: 10px;">
									Au prix net vendeur de {state.price} €
								</Typography>
								<Typography variant="h5" style="margin-top: 10px;">Prochaine étape: le vendeur doit signer le mandat de vente.</Typography>
								<Typography variant="body1" style="margin-top: 10px;">
									Une fois le mandat signé, le bien sera mis en vente sur le site.
								</Typography>
								<Button
									variant="contained"
									onClick={() => {
										window.location.href = "/dashboarda";
									}}
									style="margin-top: 20px;"
								>
									Aller à mon espace
								</Button>
							</div>
						)}
					</Paper>
				</Grid>

			</Grid>
		</div>
	);
}
const ProspectAppliance = ({ lastStep, nextStep, prospects, setProspects }) => {
	const classes = useStyles();
	const [formData, setFormData] = useState(undefined);
	const [open, setOpen] = useState(false);

	const handleClose = (value) => {
		setOpen(false);
		//setOpenSnack(true);
		//	console.log( prospects)
		console.log(formData);
		//	setProspects([...prospects, formData]);
	};
	const handleClickOpen = (cat) => {
		setOpen(true);
	};
	console.log(prospects);
	return (
		<Grid container spacing={4}>
			<Grid item xs={6}>
				<Box display="flex" justifyContent="space-between" flexDirection="row" alignItems="center">
					<Box>
						<Button style="outlined" onClick={handleClickOpen}>
							{"Je veux définir un prospect"}
						</Button>
					</Box>
					<Box>
						<Button
							style="outlined"
							onClick={() => {
								window.location.replace("/dashboard");
							}}
						>
							J'ai fini pour le moment
						</Button>
					</Box>
					{formData !== undefined && (
						<Box>
							<Button style="outlined" onClick={nextStep}>
								Je veux planifier un rendez-vous
							</Button>
						</Box>
					)}
				</Box>
				<OnboardingDialog open={open} onClose={handleClose} cat={3} set={setFormData} />
				{formData !== undefined && (
					<div style="max-width: 300px;">
						<Paper style=" padding: 10px; margin: 5px;">
							<Box display="flex" justifyContent="flex-start" flexDirection="row" alignItems="center">
								<Box>
									<AccountBoxIcon />
								</Box>
								<Box>
									<Typography variant="h6" display="inline">
										{formData.firstname} {formData.lastname}
									</Typography>
								</Box>
							</Box>
						</Paper>
					</div>
				)}
			</Grid>
			<Grid item xs={6}>
				<div style="min-height: 300px; padding: 10px; background-color: #F0F0F0; border-radius: 20px;">
					<Typography variant="h6">Ici ...</Typography>
					<Typography variant="body1">Vous pouvez inviter des acquéreurs qui ont manifesté un intéret pour ce bien</Typography>
				</div>
			</Grid>
		</Grid>
	);
};
